export default [
  {
    id: '9b27b6c71b',
    title: 'Linux下搭建Minecraft-spongeforge服务器',
    date: 'May 21, 2020',
    content: '本文主要以linux系统（Ubuntu18.04）为示范操作系统，对如何在linux系统上搭建一个Minecraft服务器进行简要描述。'
  },
  {
    id: '7682cbdcd4',
    title: 'GoogleTest安装与简单应用',
    date: 'May 11, 2020',
    content: 'GoogleTest是Google测试团队开发的用于C++代码程序测试的测试框架，它能够在Windows、Linux和Mac多平台使用。它可以支持包含单元测试(unit tests)在内的任何测试。它具有独立性、可重复、跨平台特征，允许测试者专注于测试代码本身...'
  },
  {
    id: 'fb472edc63',
    title: 'Github Actions入门',
    date: 'April 13, 2020',
    content: '该笔记主要基于阮一峰老师的《GitHub Actions 入门教程》,阮一峰老师在这篇文章中简要对Github Actions概念做了介绍，并以一个实际应用为例，十分浅显易懂。本文章中首先对其内容做一些搬运，而后对如何自动部署静态网站做一些补充...'
  }, {
    id: 'b824a382d6',
    title: 'AWS S3 初探',
    date: 'April 2, 2020',
    content: 'Amazon Simple Storage Service (Amazon S3) 是一种对象存储服务，提供行业领先的可扩展性、数据可用性、安全性和性能。数据以对象的形式存储在名为“存储桶”的资源中，单个对象大小的上限为5TB...'
  },
  {
    id: '1baa7c4500',
    title: 'rmdyh-website',
    date: 'March 12, 2020',
    content: 'A sample markdown used to test website\'s performance.'
  }
]
